const SiteMapping = {
    Nova88: 'nova88',
    IBCBet: 'ibcbet',
    PICA88: 'pica88',
    bong88: 'bong88',
    viva88: 'viva88',
    id8899: 'id8899',
    bettha88: 'bettha88', // bettha(7a5555)
    taraPlays: 'taraplays', // taraPlays(777777)
    fifabet: 'fifabet', // FifaBet (4150)
    ocean99: 'ocean99', // Ocean99 (4140)
};

export default SiteMapping;

// viva88 / bong88
// IBCBet / NewEU (PICA88) (classname 一樣但部分區塊 PICA88 沒有)
// Nova88
